var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('GGGroup', {
    attrs: {
      "prop": _vm.data.template.prop,
      "data": _vm.data.dataSource.data,
      "enable-factoid": !!_vm.data.factoid,
      "order": _vm.data.factoid && _vm.data.factoid.align
    },
    scopedSlots: _vm._u([_vm.data.factoid ? {
      key: "factoid",
      fn: function () {
        return [_vm.data.factoid ? _c(_vm.data.factoid.component, {
          tag: "component",
          attrs: {
            "data": _vm.data.dataSource.data,
            "prop": _vm.data.factoid.prop
          }
        }) : _vm._e()];
      },
      proxy: true
    } : null, {
      key: "content",
      fn: function () {
        return [_vm.data.dataSource.data.category ? _c('GGCategoryGrid', {
          attrs: {
            "list": _vm.data.dataSource.data.category
          }
        }) : _vm._e(), _vm._v(" "), Array.isArray(_vm.data.dataSource.data.brand) ? _c('GGBrandGrid', {
          attrs: {
            "list": _vm.data.dataSource.data.brand
          }
        }) : _vm._e(), _vm._v(" "), Array.isArray(_vm.data.dataSource.data.product) ? [!_vm.showProductSliderCard || _vm.data.dataSource.data.product.length < 9 ? _c('ViewportToogle', {
          scopedSlots: _vm._u([{
            key: "desktop",
            fn: function () {
              return [_c(!!_vm.data.factoid ? 'GGShrinkGrid' : 'GGWideGrid', {
                tag: "component",
                attrs: {
                  "list": _vm.data.dataSource.data.product,
                  "order": _vm.data.factoid && _vm.data.factoid.align
                },
                scopedSlots: _vm._u([{
                  key: "default",
                  fn: function (_ref) {
                    var el = _ref.el,
                        size = _ref.size;
                    return [_c('GGProduct', {
                      staticStyle: {
                        "height": "100%"
                      },
                      attrs: {
                        "product": el,
                        "size": size,
                        "meta": _vm.meta,
                        "user-cart-item": _vm.userCart[el.id]
                      },
                      on: {
                        "cart-add": function ($event) {
                          return _vm.$emit('cart-add', $event);
                        },
                        "cart-remove": function ($event) {
                          return _vm.$emit('cart-remove', $event);
                        },
                        "auth-needed": function ($event) {
                          return _vm.$emit('auth-needed');
                        }
                      }
                    })];
                  }
                }], null, false, 2979802449)
              })];
            },
            proxy: true
          }, {
            key: "mobile",
            fn: function () {
              return [_c('GGProductPromo', {
                attrs: {
                  "items": _vm.data.dataSource.data.product,
                  "count": 6
                }
              })];
            },
            proxy: true
          }], null, false, 1299337505)
        }) : _c('GGProductSliderGrid', {
          attrs: {
            "list": _vm.data.dataSource.data.product,
            "data": _vm.data.template.prop,
            "size": !!_vm.data.factoid ? 'shrink' : 'wide'
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function (_ref2) {
              var el = _ref2.el,
                  size = _ref2.size;
              return [_c('GGProduct', {
                staticStyle: {
                  "height": "100%"
                },
                attrs: {
                  "product": el,
                  "size": size,
                  "meta": _vm.meta,
                  "user-cart-item": _vm.userCart[el.id],
                  "slider-grid-styles": ""
                },
                on: {
                  "cart-add": function ($event) {
                    return _vm.$emit('cart-add', $event);
                  },
                  "cart-remove": function ($event) {
                    return _vm.$emit('cart-remove', $event);
                  },
                  "auth-needed": function ($event) {
                    return _vm.$emit('auth-needed');
                  }
                }
              })];
            }
          }], null, false, 213159678)
        })] : _vm._e()];
      },
      proxy: true
    }], null, true)
  });
}
var staticRenderFns = []

export { render, staticRenderFns }